module.exports = __webpack_public_path__ + "static/media/az.fa9c079d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/az.svg
// module id = 596
// module chunks = 0